import React, { useRef, useState } from "react";
import "../loginSignupPage.css";

import InputBox from "../../commonComponents/inputComponents/InputBox";

import { useForgetPassword } from "../../../contexts/ForgetPasswordContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import Loader from "../../commonComponents/Loader/Loader";

export default function FPStep1() {
  const [isLoading, setIsLoading] = useState(false);
  const { firstStep } = useForgetPassword();
  const phoneRef = useRef();

  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    const phoneNumber = phoneRef.current.value;

    if (!phoneNumber) {
      toast.error("لطفا شماره صحیح وارد کنید");
      setIsLoading(false);
      return;
    }

    if (isNaN(phoneNumber)) {
      toast.error("لطفا شماره صحیح وارد کنید");
      setIsLoading(false);
      return;
    }

    try {
      await firstStep(phoneNumber);
    } catch (error) {
      toast.error(error);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    navigate("otp-token");
  }

  return (
    <form action="" className="log_sign-form" onSubmit={handleSubmit}>
      <h2 className="forget-pass-header">لطفا شماره ی خود را وارد کنید</h2>
      <InputBox
        name="forget-tel"
        label="شماره موبایل"
        type="text"
        ref={phoneRef}
        gap="60px"
      />
      <button disabled={isLoading} className="log_sign-button red-submit-btn">
        {isLoading ? <Loader loading={isLoading} small dark /> : "مرحله بعدی"}
      </button>
    </form>
  );
}
